import {
  Bell,
  BellRing,
  Gavel,
  HandCoins,
  MessageCircle,
  Newspaper,
  Package,
  Search,
  ShieldCheck,
  Sparkles,
  Store,
  Wallet,
  type LucideIcon,
} from "lucide-react";
import type { NotificationCategory } from "@/api/types";

export const CATEGORY_META: Record<NotificationCategory, { label: string; icon: LucideIcon; tone: string }> = {
  MESSAGES: { label: "Chats", icon: MessageCircle, tone: "text-[var(--primary-text)]" },
  OFFERS: { label: "Offers", icon: HandCoins, tone: "text-cyan" },
  ORDERS: { label: "Orders", icon: Package, tone: "text-cyan" },
  PAYMENTS: { label: "Payments", icon: Wallet, tone: "text-success" },
  DISPUTES: { label: "Disputes & support", icon: Gavel, tone: "text-warning" },
  ALERTS: { label: "Saved items", icon: Search, tone: "text-warning" },
  PROMOTIONS: { label: "Deals", icon: Sparkles, tone: "text-magenta" },
  NEWS: { label: "News", icon: Newspaper, tone: "text-ink-soft" },
  STORE: { label: "My store", icon: Store, tone: "text-[var(--primary-text)]" },
  ACCOUNT: { label: "Security", icon: ShieldCheck, tone: "text-danger" },
};

/** Inbox filter tabs (the API's ?type=). */
export const INBOX_TABS = [
  { id: "all", label: "All" },
  { id: "chats", label: "Chats" },
  { id: "orders", label: "Orders" },
  { id: "payments", label: "Payments" },
  { id: "deals", label: "Deals" },
] as const;
export type InboxTab = (typeof INBOX_TABS)[number]["id"];

export const FALLBACK = { label: "Update", icon: Bell, tone: "text-ink-soft" };
export const LiveIcon = BellRing;
